<template>
  <div :class="modal ? 'modal is-active' : 'modal'" v-if="modal">
    <div class="modal-background"></div>
    <div class="modal-card is-815">
      <!-- dont want header footer fixed -->
      <section class="modal-card-body p0">
        <div class="modal-body-header relative mt10 pa-16">
          <button
            @click="closeModal"
            class="btn-close"
            aria-label="close"
          ></button>
          <p class="modal-card-title mt0 is-size-20px">
            {{ vg_businessLoyalityProgram.name }}
          </p>
        </div>

        <loading v-if="!loaded" />

        <template v-else>
          <div class="loyalty-questions-steps pa-16">
            <ul>
              <li>
                <p class="is-size-20px mb10 has-text-weight-medium">Step 1</p>
                <p class="is-size-16px">
                  Sign up to earn points on eligible purchases and actions!
                </p>
              </li>
              <li class="has-arrow">
                <img
                  class="mobile-rotate-90"
                  src="@/assets/img/arrow-right.png"
                  alt=""
                />
              </li>
              <li>
                <p class="is-size-20px mb10 has-text-weight-medium">Step 2</p>
                <p class="is-size-16px">
                  Redeem points at checkout and save on eligible purchases!
                </p>
              </li>
            </ul>
          </div>

          <div class="loyalty-questions-answers-panel pa-8">
            <h3 class="is-size-20px has-text-weight-semibold text-center">
              FAQ
            </h3>
            <p
              class="is-size-14 has-text-centered mt-20"
              v-if="faqs.length == 0"
            >
              No FAQs found.
            </p>
            <section
              class="accordions body-text-dark"
              v-bind:key="'faq_' + index"
              v-for="(faq, index) in faqs"
            >
              <article :class="'accordion' + (faq.active ? ' is-active' : '')">
                <div class="accordion-header toggle" @click="toggelThis(index)">
                  <p class="is-size-16px">
                    {{ index + 1 }}. {{ faq.question }}
                  </p>
                  <button class="toggle" aria-label="toggle"></button>
                </div>
                <div class="accordion-body">
                  <div class="accordion-content pt0">
                    <div
                      class="is-size-14 has-text-dark"
                      v-if="faq.type == 'default'"
                    >
                      <div
                        class="has-text-dark"
                        v-bind:key="'ans_' + index"
                        v-for="(ans, index) in faq.answers"
                      >
                        {{ ans }}
                      </div>
                    </div>
                    <div
                      class="is-size-14 has-text-dark"
                      v-if="faq.type == 'faqs'"
                    >
                      <div class="has-text-dark" v-html="faq.answer"></div>
                    </div>
                  </div>
                </div>
              </article>
            </section>
          </div>

          <div class="text-center mt30 mb20">
            <p>
              <router-link
                class="is-size-14 has-text-weight-normal is-underlined"
                target="_blank"
                :to="{
                  name: 'TermsConditions',
                  params: { business_slug: $route.params.business_slug },
                  query: $route.query,
                }"
                >Budler Terms & Conditions</router-link
              >
            </p>
            <button
              @click="closeModal"
              class="button is-primary px-1 min-w-200 mt30"
            >
              Got it!
            </button>
          </div>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import Helpers from "@/Components/Helpers/Helpers";
import { mapGetters, mapActions } from "vuex";
import BusinessLoyalityApis from "@/Components/Controllers/BusinessLoyalityApis";
import "moment-timezone";

export default {
  data() {
    return {
      modal: false,
      loaded: false,
      faqs: [],
    };
  },

  mounted() {
    const self = this;
    bus.$on("show-modal-loyalty-questions", async (payload) => {
      if (
        this.vg_businessLoyalityProgram.is_active &&
        this.vg_businessLoyalityProgram.id
      ) {
        this.modal = payload;
        if (
          this.vg_businessLoyalityProgram.tokens &&
          this.vg_businessLoyalityProgram.tokens.length > 0
        ) {
          this.loaded = false;

          let faqDefaultApi =
            BusinessLoyalityApis.fetchBusinessLoyalityFaqsDefault(
              this.vg_businessLoyalityProgram.tokens[0].token
            );
          let faqsApi = BusinessLoyalityApis.fetchBusinessLoyalityFaqs(
            this.vg_businessLoyalityProgram.tokens[0].token
          );
          Promise.all([faqDefaultApi, faqsApi]).then(function (res) {
            let count = 0;
            // Handle the default one first
            if (res[0].status == 200) {
              let unwantedKeys = ["api_version", "msg"];
              for (let key in res[0].data) {
                //not the keys
                if (unwantedKeys.indexOf(key) == -1) {
                  let eachCat = res[0].data[key];
                  eachCat.forEach((item) => {
                    count++;
                    item.type = "default";
                    item.active = count == 1 ? true : false;
                    self.faqs.push(item);
                  });
                }
              }
            }

            // Lets handle faqs
            if (res[1].status == 200) {
              res[1].data.payload.forEach((catFaq) => {
                let categoryFaq = catFaq.faqs;
                if (categoryFaq.length > 0) {
                  categoryFaq.forEach((faqList) => {
                    count++;
                    faqList.type = "faqs";
                    faqList.active = count == 1 ? true : false;
                    self.faqs.push(faqList);
                  });
                }
              });
            }
            self.loaded = true;
          });
        }
      }
    });
  },

  computed: {
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_selectedStore: "location/selected",
      vg_businessProfile: "businessprofile/detail",
      vg_businessLoyalityProgram: "businessprofile/businessLoyality",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
    }),
  },

  beforeDestroy() {
    bus.$off("show-modal-loyalty-questions");
  },

  methods: {
    closeModal() {
      this.faqs = [];
      this.modal = false;
    },

    toggelThis(index) {
      this.faqs[index].active = !this.faqs[index].active;
      this.faqs.map((item, itemIndex) => {
        if (index != itemIndex) {
          item.active = false;
        }
      });
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    }),
  },
};
</script>

<style scoped>
.modal-body-header .btn-close {
  position: absolute;
  right: 15px;
  top: 10px;
  background: none;
}
.modal-body-header .btn-close:hover {
  background: #333;
}
.loyalty-questions-steps ul {
  display: flex;
  justify-content: center;
}
.loyalty-questions-steps ul li {
  max-width: 34%;
  padding: 20px;
  padding-top: 0px;
  position: relative;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

@media only screen and (max-width: 768px) {
  .loyalty-questions-steps ul {
    align-items: center;
    flex-direction: column;
    align-items: flex-start;
  }
  .loyalty-questions-steps ul li {
    width: 100%;
    max-width: 100%;
    padding: 20px 0 20px 0;
  }
  .mobile-rotate-90 {
    transform: rotate(90deg);
  }
  .loyalty-questions-steps ul li:first-child {
    padding-top: 0px;
  }
  li.has-arrow {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}
</style>